import {
  validationSchemaCoopConsent,
  validationSchemaHuseierneMembershipStatus,
} from "Components/Form/Partner/partnerFormValidation";
import { isDefined, isNull } from "Utils/functions";

import { Cart } from "Store/cart/cartInterfaces";
import { Partner } from "Store/partners/partnerInterfaces";

export const withPartnerInitialValues = (
  partnerId: Partner,
  initialValues: any,
  cart: Cart | null,
  withPartnerValidation: boolean,
): any => {
  if (isDefined(initialValues)) {
    if (withPartnerValidation && partnerId === Partner.COOP) {
      return {
        ...initialValues,
        coopConsent:
          isDefined(cart) && hasStep1PreviouslyBeenFilledOut(initialValues)
            ? true
            : undefined,
      };
    }
    if (withPartnerValidation && partnerId === Partner.HUSEIERNE) {
      return {
        ...initialValues,
        huseierneMembershipStatus: isNull(cart)
          ? undefined
          : cart.customer.partnerCustomerInfo?.huseierneMembershipStatus,
      };
    }
    return initialValues;
  }
  return {};
};

export const withPartnerValidationSchema = (
  partnerId: Partner | undefined,
  validationSchema: any,
  withPartnerValidation: boolean,
): any => {
  if (withPartnerValidation && partnerId === Partner.COOP) {
    return validationSchema.concat(validationSchemaCoopConsent());
  }
  if (withPartnerValidation && partnerId === Partner.HUSEIERNE) {
    return validationSchema.concat(validationSchemaHuseierneMembershipStatus());
  }
  return validationSchema;
};

const hasStep1PreviouslyBeenFilledOut = (initialValues: any): boolean =>
  Object.values(initialValues).some((value) => isDefined(value));
